var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcTransgender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.6667C14.8012 14.6667 16.6667 12.8012 16.6667 10.5C16.6667 9.562 16.3567 8.69638 15.8336 8C15.7067 7.83105 15.5673 7.67205 15.4167 7.5244M12.5 14.6667C10.1988 14.6667 8.33333 12.8012 8.33333 10.5C8.33333 9.33442 8.81193 8.28062 9.58333 7.5244M12.5 14.6667V18M12.5 20.9167V18M12.5 18H9.58333M12.5 18H15.4167M20 3H16.5M20 3V6.5M20 3L15.4167 7.5244M15.4167 7.5244C14.6651 6.78763 13.6356 6.33333 12.5 6.33333C11.3644 6.33333 10.3349 6.78763 9.58333 7.5244M9.58333 7.5244L8 6M5 3H8M5 3V6M5 3L8 6M8 6L6 8M8 6L10 4",
    stroke: "#000000",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTransgender);
export default __webpack_public_path__ + "static/media/ic_transgender.ae6db237edb15dfd6553e785c9c778d1.svg";
export { ForwardRef as ReactComponent };